import {Component, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {ApiService} from '../services/api.service';
import {TaskDescService} from '../services/task-desc.service';
import {TaskBarService} from '../services/task-bar.service';
import * as moment from 'moment';

@Component({
  selector: 'app-tasks-panel',
  templateUrl: './tasks-panel.component.html',
  styleUrls: ['./tasks-panel.component.css']
})
export class TasksPanelComponent implements OnInit {
  public isLoaded = false;
  private myTaskList: any[];
  private limiter = 65;
  errorTaskList = false;
  haveTasks = false;

  constructor(private apiService: ApiService,
              private taskDescService: TaskDescService,
              public taskbarService: TaskBarService) {
  }

  ngOnInit() {
    // this.apiService.getMyTasks().subscribe(
    //   (response) => {
    //     this.errorTaskList = false;
    //     if (response.status === 200) {
    //       const data: any = response.body;
    //       data.forEach(item => {
    //         if (item.source === '_1C') {
    //           item.source = item.source.substr(1);
    //           item.date = item.date.substr(0, 8);
    //           item.date = moment(item.date).format('YYYY-MM-DD');
    //           item.deadLine = item.deadLine.substr(0, 8);
    //           item.deadLine = moment(item.deadLine).format('YYYY-MM-DD');
    //         }
    //         if (item.description.length > 72) {
    //           item.short = item.description.substr(0, 72) + '...';
    //         } else {
    //           item.short = item.description;
    //         }
    //         item.isOpen = false;
    //       });
    //       this.myTaskList = data;
    //       if (this.myTaskList.length > 0) {
    //         this.haveTasks = true;
    //       } else {
    //         this.haveTasks = false;
    //       }
    //       this.isLoaded = true;
    //     }
    //     if (response.status === 204) {
    //       this.haveTasks = false;
    //       this.isLoaded = true;
    //     }

    //   },
    //   () => {
    //     this.isLoaded = true;
    //     this.errorTaskList = true;
    //   }
    // );

  }

  taskAction(taskInfo) {
    taskInfo.isOpen = !taskInfo.isOpen;
  }

  openFullDesc(taskInfo) {
    this.taskDescService.setModalTaskInfo(
      taskInfo.source,
      taskInfo.number,
      taskInfo.fullDescription,
      taskInfo.author,
      taskInfo.startDate,
      taskInfo.date,
      taskInfo.executor,
      taskInfo.endDate,
      taskInfo.deadLine);
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/tasks-panel/tasks-panel.component.ts